import { LoginOrRegistrationModalContent } from "./LoginOrRegistrationModalContent"
import { Modal } from "antd"
import {useStore} from "@/store/useStore";
import {useCallback} from "react";
import {getPersonPageRoute} from "@/routes/routes";
import {useNavigate} from "react-router-dom";
import {useAuth} from "@/provider/auth/useAuth";

export const LoginOrRegistrationModal = () => {
    const {signin} = useAuth();
    const {isLoginOrRegistrationModalVisible, showLoginOrRegistrationModal} = useStore();
    const navigate = useNavigate();
    
    const onLoginOrRegisterHide = useCallback(() => {
        showLoginOrRegistrationModal(false);
    }, []);

    const onGoToPersonPage = (token: string) => {
        onLoginOrRegisterHide();
        signin(token);
        setTimeout(() => {
            navigate(getPersonPageRoute());
        }, 200)
        
    };
    return (
        <Modal
            zIndex={18}
            key="login-or-register-modal"
            centered
            open={isLoginOrRegistrationModalVisible}
            footer={null}
            destroyOnHidden
            width={'800px'}
            onCancel={onLoginOrRegisterHide}
        >
            <div className="text-[46px] font-medium text-center leading-[59px] mt-[90px]">Особистий кабінет ВПО</div>
            <LoginOrRegistrationModalContent
                mode={'both'}
                onHide={onLoginOrRegisterHide}
                onFinish={onGoToPersonPage}
            />
        </Modal>
    )
}